import React from 'react';

export function NavButton({ link, label, image }) {
  return (
    <a
      href={link}
      aria-label={label}
      className="NavButton"
      id={`nav-button-${label.toLowerCase()}`}
      onMouseEnter={randomizeBackground}
    >
      <div className="buttonBackground">
        {image && <img src={image} alt={label} className="nav-button-image" />}
        <span className="nav-button-label glyph">{label}</span>
      </div>
    </a>
  );
}

function randomizeBackground(event) {
  const accent = getComputedStyle(document.body).getPropertyValue("--accent").trim();
  const accent2 = getComputedStyle(document.body).getPropertyValue("--accent2").trim();
  const gradient = `linear-gradient(${Math.floor(Math.random() * 360)}deg, ${accent}, ${accent2})`;
  event.currentTarget.style.backgroundImage = gradient;
}